import React from 'react';
import { useCharitableGivingContext } from '../../context/useCharitableGivingContext';
import { ReviewItem } from '../Review/components/ReviewItem';
import { DafYear, DafYearOption } from '../../api/useCharitableGivingQuery';

const getDonationYearValue = (donationYear: DafYear | null, yearOptions: DafYearOption[]) => {
  if (!donationYear) {
    return '—';
  }

  if (donationYear.type === 0) {
    return donationYear.year;
  }

  const foundOption = yearOptions.find(({ type }) => type === donationYear.type);

  return foundOption?.label ?? '—';
};

export const DafDonationYearReview = () => {
  const {
    workflow: {
      data: { dafDonationStartYear, dafDonationEndYear },
      options: { dafStartYearOptions, dafEndYearOptions },
    },
  } = useCharitableGivingContext();

  const donationStartYearValue = getDonationYearValue(dafDonationStartYear, dafStartYearOptions);
  const donationEndYearValue = getDonationYearValue(dafDonationEndYear, dafEndYearOptions);

  return (
    <>
      <ReviewItem
        label={dafDonationEndYear ? 'Donation Start Year' : 'Donation Year'}
        value={donationStartYearValue}
      />

      {dafDonationEndYear && <ReviewItem label="Donation End Year" value={donationEndYearValue} />}
    </>
  );
};
